__turbopack_context__.v({
  "buttonCallBack": "Modal-module__1KjhBG__buttonCallBack",
  "close": "Modal-module__1KjhBG__close",
  "closeButton": "Modal-module__1KjhBG__closeButton",
  "error": "Modal-module__1KjhBG__error",
  "hiddenInput": "Modal-module__1KjhBG__hiddenInput",
  "line": "Modal-module__1KjhBG__line",
  "modalWindow": "Modal-module__1KjhBG__modalWindow",
  "normalInput": "Modal-module__1KjhBG__normalInput",
  "overlay": "Modal-module__1KjhBG__overlay",
  "subtitle": "Modal-module__1KjhBG__subtitle",
  "title": "Modal-module__1KjhBG__title",
});
